// removed by extract-text-webpack-plugin
module.exports = {"extraElementWrap":"general__extraElementWrap___1wZXn pinTL position-absolute","extraElementInlineWrap":"general__extraElementInlineWrap___1XODA display-inlineBlock position-relative","extraElement":"general__extraElement___1Wa2u pinCenter position-absolute","sadIcon":"general__sadIcon___1D-cI fill-white transitionDuration-xxl transitionProperty-all transitionTimingFunction-cv-easeOutCircular","sadIconHidden":"general__sadIconHidden___glrrh opacity-0"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-button/ExtraElement/style/general.css
// module id = 109
// module chunks = 0 2